import PropTypes from "prop-types"
import React from "react"
import Modal from "react-modal"

import { useTranslate } from "context/translateContext"
import Button from "shared/components/Button"
import ModalContent from "shared/components/Modal/ModalContent"
import ModalFooter from "shared/components/Modal/ModalFooter"
import ModalHeader from "shared/components/Modal/ModalHeader"

const PlanChangeModal = ({ submitting, onClose, onSubmit }) => {
  const { t: translate } = useTranslate()
  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      contentLabel="Plan upgrade"
      className="popup"
      overlayClassName="popupOverlay"
      ariaHideApp={false}
    >
      <ModalHeader onRequestClose={onClose}>
        <h1>{translate("Plan upgrade")}</h1>
        <span className="fs-12 c-motive--dark">
          {translate("Change current plan")}
        </span>
      </ModalHeader>
      <ModalContent>
        <p>
          {translate(
            "By clicking 'Yes, change my plan' you will initiate a change of your rate plan to a new plan"
          )}
          <br />
          {translate(
            "The change will be effective from the date of your next issued invoice."
          )}
          <br />
          <br />
          <strong>
            {translate("This operation can take up to 30 seconds.")}
          </strong>
        </p>
      </ModalContent>
      <ModalFooter>
        <div className="row">
          <div className="col-xs-6">
            <Button type="button" onClick={onClose} size="large" block>
              {translate("Cancel")}
            </Button>
          </div>
          <div className="col-xs-6">
            <Button
              onClick={onSubmit}
              loading={submitting}
              disabled={submitting}
              variation="primary"
              size="large"
              block
            >
              {translate("Yes, change my plan")}
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

PlanChangeModal.propTypes = {
  submitting: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default PlanChangeModal
